export enum PDFExportType {
  Value = 'sale',
  Rental = 'rental',
}

export enum PreferencePDFExportType {
  All = 'all',
  Selected = 'selected',
}
